import { summaryTableStyles as styles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.orderLines = {
    ...styles.orderLines,
    gridContainer: {
        css: css`
            .card_container__wrapper {
                border-top: 1px solid ${getColor("common.border")};
            }
            .card_container__wrapper ~ .card_container__wrapper {
                border-top: 1px solid ${getColor("common.border")};
            }
        `,
    },
};
